<template>
  <div style="position: relative;">
      <el-select
        :disabled="disabled"
        :multiple="multiple"
        clearable
        filterable
        collapse-tags
        @change="handleChange"
        :value="data"
        :placeholder="$t('请选择')"
      >
      <!-- @visible-change="handleVisibleChange" -->
        <el-option
          :label="item.name"
          :value="item.value"
          v-for="(item, index) in operator"
          :key="index"
        ></el-option>
      </el-select>
    <el-checkbox  class="box" v-if="allSelect" v-model="checked" @change="handleAll">{{ $t('全选') }}</el-checkbox>
  </div>
</template>

<script>
import { getCascade } from "@/services/customer";

export default {
  name: "MultipleOperator",
  props: {
    value: {},
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    allSelect:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return { data: [], operator: [],checked:false };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value) {
          this.data = value;
        } else {
          this.data = [];
        }
      },
    },
  },
  methods: {
    setSelectValue(value) {
      this.data = {
        value: value,
        name: "",
      };
    },
    handleChange(value) {
      this.$emit("input", value);
      this.$emit("change", value);
      this.data = value;
      if(this.operator.length==this.data.length){
        this.checked=true
      }else{
        this.checked=false
      }
    },

    async loadData() {
        const response = await getCascade({});
            if (response) {

              this.operator = response.data.factoryList.map((item, i) => {
                return {name: item.factoryName, value: item.id}
              })
            }
    },
    handleAll(){
      if(this.checked){
        let  arr =this.operator.map((item)=>{
          return item.value
        })


        this.$emit("change", arr);
        this.$emit("input", arr);
        this.data=arr;


      }else{
        this.$emit("change", []);
        this.$emit("input", []);
        this.data=[];
      }
    }
  },
};
</script>

<style scoped>
.box{
  position: absolute;
  top: 0px;
  right: -92px;
}

</style>



// WEBPACK FOOTER //
// src/components/operation/MultipleFactory.vue